<template>
  <v-form @submit.prevent="addTodo" class="mb-4">
    <v-text-field
      autofocus
      clearable
      flat
      hide-details
      label="Add Todo"
      outlined
      prepend-inner-icon="mdi-plus"
      solo
      v-model.trim="newTodo.text"
    >
      <template v-slot:append>
        <v-btn @click="newTodo.starred = !newTodo.starred" icon>
          <v-icon
            :color="newTodo.starred ? 'yellow darken-2' : ''"
            v-text="newTodo.starred ? 'mdi-star' : 'mdi-star-outline'"
          />
        </v-btn>
      </template>
    </v-text-field>
  </v-form>
</template>

<script>
export default {
  name: 'NewTodoForm',
  methods: {
    addTodo() {
      this.$store.dispatch('addTodo', this.newTodo).then(() => {
        this.newTodo = {
          text: '',
          starred: false,
        }
      })
    },
  },
  data: () => ({
    newTodo: {
      text: '',
      starred: false,
    },
  }),
}
</script>

<style scoped></style>
